<div class="appointment-planner__body__planner-result__appointments__item__left-part">
    <div class="appointment-planner__body__planner-result__appointments__item__left-part__header">
        <span class="appointment-planner__body__planner-result__appointments__item__left-part__header__title" style="text-transform: uppercase"> {{ center.libelleCentre }}</span>
        <span class="appointment-planner__body__planner-result__appointments__item__left-part__header__distance">{{ center.distanceClient }} km</span>
    </div>
    <div class="appointment-planner__body__planner-result__appointments__item__left-part__address">
        <div>{{ center.adresse1 }}</div>
        <div>{{ center.codePostal }}&nbsp;{{ center.ville }}</div>
    </div>
</div>
<div *ngIf="(center && center.rendezVous.length < 0) || center.rendezVous.length == 0" class="appointment-planner__body__planner-result__appointments__item__right-part">
    <div class="appointment-planner__body__planner-result__appointments__item__noappointmentlabel">
        {{ 'appointment.appointment-planner.appointments.item.noappointment' | i18n }}
    </div>
    <button
        #callBackBtn
        data-tag-commander=""
        data-tagcommander-id=""
        (click)="selectCenterToCallBack(center)"
        class="appointment-planner__body__planner-result__appointments__item__call-button grid-10 centered button button--download button--noBackground"
    >
        {{ 'appointment.appointment-planner.appointments.item.callback' | i18n }}
    </button>
</div>
<div *ngIf="center.rendezVous.length > 0 && center.rendezVousSortedByDate.length > 0" class="appointment-planner__body__planner-result__appointments__item__right-part">
    <div class="grid-12">
        <div *ngFor="let sortedAppointment of center.rendezVousSortedByDate.slice(0, maxNumberOfDaysToShow)" class="appointment-planner__body__planner-result__appointments__item__right-part__appointment-date">
            <div class="appointment-planner__body__planner-result__appointments__item__right-part__appointment-date__date">
                {{ sortedAppointment.date.dayName }}
            </div>
            <div class="appointment-planner__body__planner-result__appointments__item__right-part__appointment-date__date--little">
                {{ sortedAppointment.date.dayNumber + ' ' + sortedAppointment.date.monthName }}
            </div>
            <div
                *ngFor="let appointment of sortedAppointment.appointments.slice(0, maxNumberOfAppointmentsByDay)"
                (click)="selectAppointment(appointment)"
                data-tag-commander=""
                data-tagcommander-id="tagCo.appointment.appointmentplanner.takeappointment.list.button"
                class="appointment-planner__body__planner-result__appointments__item__right-part__appointment-date__time"
            >
                {{ getFormattedTime(appointment.dateDebut) }}
            </div>
        </div>
    </div>
    <button #moreAvailibilityBtn (click)="navigateToAppointmentDetails()" data-tag-commander="" data-tagcommander-id="" class="grid-12 appointment-planner__body__planner-result__appointments__item__link">
        {{ 'appointment.appointment-planner.appointments.item.moreavailibility' | i18n }}
    </button>
</div>
